import Vue from 'vue'

class Address {
  public zip = ''
  public city = ''
  public street = ''
  public number = ''

  reset () {
    this.zip = ''
    this.city = ''
    this.street = ''
    this.number = ''
  }

  get address () {
    return {
      zip: this.zip,
      city: this.city,
      street: this.street,
      number: this.number,
    }
  }
}

export const AddressObservable = Vue.observable(new Address())
